import * as types from "./mutation-types";
import CacheHelper from "@/cacheHelper";
import { isEmpty } from "lodash";

const cacheConfig = {
  key: "WIDGET_EVENTS",
  ttl: 60 * 5, // 5 mins
};

const cache = new CacheHelper(cacheConfig);

/**
 * All VueX actions should go here.
 * They should check if data exists via the cache, and any api calls should be made to the /flat endpoint by default
 */
export const actions = {
  async getLargestLimit({ rootGetters, commit }) {
    const newsWidgets = rootGetters["widgets/getWidgetsByType"](
      "events-widget"
    );
    const limits = [];
    let largest = 10;
    if (!isEmpty(newsWidgets)) {
      newsWidgets.forEach((widget) => {
        limits.push(parseInt(widget.props.limit));
      });

      largest = limits.sort((a, b) => b - a)[0];
    }

    commit(types.SET_MAX_QUERY_SIZE, largest);
    return Promise.resolve(largest);
  },
  /**
   * Get a list of all the users events
   * Filtered by interest groups
   */
  async getEvents({ commit, rootState, state, dispatch }) {
    let events;

    if (cache.existsAndIsValid()) {
      events = cache.getItem(cacheConfig.key);
      commit(types.ADD_EVENTS, events);

      return Promise.resolve(events);
    }

    const query = {
      sort: [
        {
          start_date: {
            order: "asc",
          },
        },
      ],
      query: {
        bool: {
          must: [
            {
              term: {
                status: "approved",
              },
            },
          ],
        },
      },
      size: state.props.limit,
    };

    if (state.status !== "WORKING") {
      commit(types.SET_STATUS, "WORKING");
      try {
        events = await dispatch(
          "Events/query",
          {
            query,
            hidePast: true,
          },
          { root: true }
        );

        commit(types.ADD_EVENTS, events);
        cache.setItem(cacheConfig.key, events, true);
        commit(types.SET_STATUS, "WAITING");
        return Promise.resolve(events);
      } catch (err) {
        console.error({ ...err });
        commit(types.SET_STATUS, "WAITING");
        return Promise.reject(err);
      }
    }
  },

  /**
   * Set the filter limit of results
   */
  async setLimit({ commit }, limit) {
    commit(types.SET_FILTER_LIMIT, limit);
    return Promise.resolve(limit);
  },

  /**
   * Clear localStorage cache
   */
  async clearCache(context) {
    cache.removeItem(cacheConfig.key);
    return Promise.resolve(cacheConfig.key);
  },
};
